import { defineAsyncComponent } from 'vue';

const SettingLayout = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/views/common/SettingLayout.vue')
);

const PopupAddTask = defineAsyncComponent(() =>
  import(/*webpackChunkName:'PopupAddTask'*/ '@/components/popup/popup-add-task/PopupAddTask.vue')
);

const PopupForwardTask = defineAsyncComponent(() =>
  import(/*webpackChunkName:'PopupForwardTask'*/ '@/components/popup/popup-add-task/PopupForwardTask.vue')
);

const PopupWarningSelectUser = defineAsyncComponent(() =>
  import(/*webpackChunkName:'PopupWarningSelectUser'*/ '@/components/popup/popup-warning-select-user/PopupWarningSelectUser.vue')
);

const PopupAssignmentGroup = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/components/popup/PopupAssignmentGroup.vue')
);

const PopupNotification = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/components/popup/PopupNotification.vue')
);

const PopupAgreementLicense = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/components/popup/popup-agreement-license/PopupAgreementLicense.vue')
);

const PopupMemberAssignment = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/components/popup/PopupMemberAssignment.vue')
);

const PopupExpandChart = defineAsyncComponent(() =>
  import(/*webpackChunkName:'PopupExpandChart'*/ '@/components/popup/popup-expand-chart/PopupExpandChart.vue')
);

const PopUpShareFile = defineAsyncComponent(() =>
  import('@/components/ms-file/PopUpShareFile.vue')
);

const MsPopupPreviewFile = defineAsyncComponent(() =>
  import('@/components/ms-file/MsPopupPreviewFile.vue')
);
const DashboardGridDetail = defineAsyncComponent(() =>
  import('@/views/report/dashboard-popup/DashboardGridDetail.vue')
);
const PopupHandoverTask = defineAsyncComponent(() =>
  import('@/components/popup/popup-handover-task/PopupHandoverTask.vue')
);

const DepartmentDetail = defineAsyncComponent(() =>
  import('@/views/setting/department/DepartmentDetail.vue')
);

const SettingOrderDepartment = defineAsyncComponent(() =>
  import('@/views/setting/department/SettingOrderDepartment.vue')
);

const AddUserPopup = defineAsyncComponent(() =>
  import('@/views/setting/user-role/AddUserPopup.vue')
);

const TransferUserPopup = defineAsyncComponent(() =>
  import('@/views/setting/user-role/TransferUserPopup.vue')
);

const PopupNotifyCustom = defineAsyncComponent(() =>
  import('@/components/popup/PopupNotifyCustom.vue')
);


const JobTitleDetail = defineAsyncComponent(() =>
  import('@/views/setting/general_setting/popup/JobTitleDetail.vue')
);
const PopupImport = defineAsyncComponent(() =>
  import(/*webpackChunkName:'PopupExpandChart'*/'@/components/popup/popup-import/PopupImport.vue')
);

const PopupSelectOrganization = defineAsyncComponent(() =>
  import(/*webpackChunkName:'PopupSelectOrganization'*/ '@/components/popup/PopupSelectOrganization.vue')
);

const AddUserRole = defineAsyncComponent(() =>
  import('@/views/setting/user-role/AddUserRole.vue')
);

const PopupSelectProfileQLCB = defineAsyncComponent(() =>
  import('@/views/setting/connectQLCB/PopupSelectProfileQLCB.vue')
);

const PopupMappingDictionary = defineAsyncComponent(() =>
  import('@/views/setting/connectQLCB/PopupMappingDictionary.vue')
);
const PopupTourGuide = defineAsyncComponent(()=> 
  import('@/components/popup/PopupTourGuide.vue')
);
const PopupRepeatTask = defineAsyncComponent(()=> 
  import('@/components/repeatTask/PopupRepeatTask.vue')
);

const PopupSettingNoify = defineAsyncComponent(() =>
  import('@/components/ms-notify/PopupSettingNotify.vue')
);

const PopupUpdateTaskDeadline = defineAsyncComponent(() =>
  import('@/components/popup/popup-add-task/PopupUpdateTaskDeadline.vue')
);

export function registerCommonPopup(app) {
  app.component('PopupNotifyCustom', PopupNotifyCustom);
  app.component('AddUserPopup', AddUserPopup);
  app.component('TransferUserPopup', TransferUserPopup);
  app.component('SettingOrderDepartment', SettingOrderDepartment);
  app.component('DepartmentDetail', DepartmentDetail);
  app.component('SettingLayout', SettingLayout);
  app.component('PopupAddTask', PopupAddTask);
  app.component('PopupForwardTask', PopupForwardTask);
  app.component('PopupWarningSelectUser', PopupWarningSelectUser);
  app.component('PopupAssignmentGroup', PopupAssignmentGroup);
  app.component('PopupNotification', PopupNotification);
  app.component('PopupMemberAssignment', PopupMemberAssignment);
  app.component('PopUpShareFile', PopUpShareFile);
  app.component('MsPopupPreviewFile', MsPopupPreviewFile);
  app.component('PopupExpandChart', PopupExpandChart);
  app.component('DashboardGridDetail', DashboardGridDetail);
  app.component('PopupAgreementLicense', PopupAgreementLicense);
  app.component('PopupHandoverTask', PopupHandoverTask);
  app.component('PopupImport', PopupImport);
  app.component('JobTitleDetail', JobTitleDetail);
  app.component('PopupSelectOrganization', PopupSelectOrganization);
  app.component('AddUserRole', AddUserRole);
  app.component('PopupSelectProfileQLCB', PopupSelectProfileQLCB);
  app.component('PopupMappingDictionary', PopupMappingDictionary);
  app.component('PopupTourGuide', PopupTourGuide);
  app.component('PopupSettingNoify', PopupSettingNoify);
  app.component('PopupRepeatTask', PopupRepeatTask);
  app.component('PopupUpdateTaskDeadline', PopupUpdateTaskDeadline);
}
